/**
 * Created by anatoly on 29.06.2026
 */

const BoosterUnlockedWindow = Prefab.createWindow("boosterunlockedwindow", "boosterunlockedwindow_prefab_json", {
    theme: () => bundles.boosterunlockedwindow.jsons.theme_json
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    UNLOCKED_WINDOW_COLOR: new cc.Color(196, 124, 97, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    UNLOCKED_WINDOW_TEXT: {
        size: 43,
        name: "nostroke",
        color: cleverapps.styles.COLORS.UNLOCKED_WINDOW_COLOR
    }
});